import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { createAction, props } from '@ngrx/store';
import { AutomationFlowConfig } from '../../interfaces/automation-flow-config.interface';
import { AutomationFlow } from '../../enums/automation-flow.enum';
import { AutomationRule } from '../../interfaces/automation-rule.interface';

export const GetFlowConfigurations = createAction(
  '[Automation] Get Flow Configurations'
);

export const GetFlowConfigurationsSuccess = createAction(
  '[Automation] Get Flow Configurations Success',
  props<{configs: AutomationFlowConfig[]}>()
);

export const GetFlowRules = createAction(
  '[Automation] Get Flow Rules',
  props<{flow: AutomationFlowConfig, page: number, perPage: number, status?: boolean}>()
);

export const GetFlowRulesSuccess = createAction(
  '[Automation] Get Flow Rules Success',
  props<{rules: AutomationRule[], total: number, page: number, perPage: number, totalPages: number, currentPage: number, hasMore: boolean}>()
);

export const GetFlowRulesFail = createAction(
  '[Automation] Get Flow Rules Fail'
);

export const DeleteRule = createAction(
  '[Automation] Delete Rule',
  props<{id: string}>()
);

export const DeleteRuleSuccess = createAction(
  '[Automation] Delete Rule Success',
  props<{id: string}>()
);

export const DeleteRuleFail = createAction(
  '[Automation] Delete Rule Fail'
);

export const SetDryRunStatus = createAction(
  '[Automation] Set Dry Run Status',
  props<{id: string, dryRun: boolean}>()
);

export const SetDryRunStatusSuccess = createAction(
  '[Automation] Set Dry Run Status Success',
  props<{id: string, dryRun: boolean}>()
);

export const SetDryRunStatusFail = createAction(
  '[Automation] Set Dry Run Status Fail'
);

export const SaveRule = createAction(
  '[Automation] Save Rule',
  props<{body: any}>()
);

export const SaveRuleSuccess = createAction(
  '[Automation] Save Rule Success',
  props<{rule: AutomationRule}>()
);

export const SaveRuleFail = createAction(
  '[Automation] Save Rule Fail'
);

export const UpdateRuleStatusFilter = createAction(
  '[Automation] Update Automation Rule Status Filter',
  props<{option: string}>()
);

export const ClearRuleFilter = createAction(
  '[Automation] Clear Rule Filter'
);

export const ExportDryrunData = createAction(
  '[Automation] Export Dryrun Data',
  props<{
    flowConfig: AutomationFlowConfig;
    ruleIds: string[];
    sendAtFrom: string;
    sendAtTo: string;
    practiceId: string;
  }>()
);

export const ExportDryrunDataSuccess = createAction(
  '[Automation] Export Dryrun Data Success'
);

export const ExportDryrunDataFailure = createAction(
  '[Automation] Export Dryrun Data Failure',
  props<{ error: any }>()
);